import { render, staticRenderFns } from "./MainLeadership.vue?vue&type=template&id=22c0a852&scoped=true&"
import script from "./MainLeadership.vue?vue&type=script&lang=ts&"
export * from "./MainLeadership.vue?vue&type=script&lang=ts&"
import style0 from "./MainLeadership.vue?vue&type=style&index=0&id=22c0a852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c0a852",
  null
  
)

export default component.exports